<template>
  <div class="email">
    <div class="email__top">
      <div class="email__top__arrow" @click="goToPrevStep">
        <sm-icon class="email__top__arrow__green-icon" size="medium" icon="arrow-left"/>
      </div>
      <p class="email__top__title">Este es el mensaje que enviaremos a nuestros usuarios cuando sea aprobado por Alegra</p>
    </div>

    <div class="email__header">
      <div class="email__header__subject">Asunto</div>
      <div class="email__header__content">Tenemos una excelente noticia para ti</div>
    </div>

    <div contenteditable="false" class="email__body">
      <p class="email__body__parr">Hola,</p>
      <p class="email__body__parr"></p>
      <p class="email__body__parr">
        Gracias a nuestra alianza con {{ me.company }}, compañía facilitadora de créditos para PYMES
      </p>
      <p class="email__body__parr">
        ¡Tienes un cupo pre-aprobado para tu empresa!
      </p>
      <p class="email__body__parr"></p>
      <p class="email__body__parr">Si te interesa, haz clic aquí y un especialista de crédito del equipo de {{ me.company }} te contactará en las próximas 24 horas.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Email',
  computed: {
    me () {
      return this.$store.getters.me
    }
  },
  methods: {
    goToPrevStep () {
      this.$store.commit('goToPrevStep')
    }
  }
}
</script>

<style>
.email__top {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}

.email__top__arrow {
  color: #00b19d;
  font-size: large;
  font-weight: bold;
  text-align: center;

  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  height: fit-content;
  height: -moz-fit-content;
  height: -webkit-fit-content;
  line-height: 2;
  width: 37px;
}

.email__top__arrow__green-icon {
  color: #00b19d;
}

.email__top__arrow__green-icon:hover {
  opacity: 0.7;
}
.email__top__title {
  color: #00535e;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  text-align: center;

  width:100%;
}

.email__header {
  align-items: center;
  border-color: #cccccc;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 35px 0 15px 0;
  width: 100%;
}

.email__header__subject {
  color: #595959;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;

  background-color: #f9fafd;
  border-color: #cccccc;
  border-style: solid;
  border-width: 0 1px 0 0;
  height: 30px;
  line-height: 30px;
  padding: 2px 20px;
  width: fit-content;
  width: -moz-fit-content;
}

.email__header__content {
  color: #595959;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  text-align: left;

  background-color: white;
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
  width: 100%;
}

.email__body {
  border-color: #cccccc;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  min-height: 350px;
  padding: 20px 0;
  width: 100%;
}

.email__body__parr {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  text-align: left;

  height: 24px;
  padding: 0 20px;
}
</style>
